module.exports = __webpack_public_path__ + "img/source04_04.3e2dc897.png";